import NamedDto from 'modules/base/dto/NamedDto';

export class AspectOutputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.attributeClass = null;
		/** @type {string} */
		this.modelFieldName = null;
	}

	/**
	 * @typedef {Object} _AspectOutputAttributeEditDtoProps
	 * @property {string} attributeClass
	 * @property {string} modelFieldName
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AspectOutputAttributeEditDtoProps} AspectOutputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {AspectOutputAttributeEditDtoProps} props
	 * @returns {AspectOutputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.attributeClass = props.attributeClass;
		this.modelFieldName = props.modelFieldName;
		return this;
	}
}

export default AspectOutputAttributeEditDto;
